import { common } from '@/constant/company';
import { STORAGE_KEY } from '@/constant/constant';
import { companyUUID } from '@/service/api';
import { getCookie, setCookie } from '@/utils/cookie';
import { getLocal, setLocal } from '@/utils/storage';
import { customerCreate } from '@/utils/cartq';
import { executeWhenReady } from '@/utils/execute';

// 校验email
export function isEmail(strEmail) {
  if (`${strEmail}`.search(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/) != -1) {
    return true;
  } else {
    return false;
  }
}

// 收集表单
export function collectionForm(selector?: string) {
  const ret = {};
  const container = selector ? document.querySelector(selector) : document;

  const inputs = container?.querySelectorAll('input');
  inputs?.forEach((item: any) => {
    const name = item.getAttribute('name') || item.getAttribute('id');
    if (!ret[name]) {
      ret[name] = item.value || item._value || '';
    }
  });

  const selects = container?.querySelectorAll('select');
  selects?.forEach((item: any) => {
    const name = item.getAttribute('name') || item.getAttribute('id');
    if (!ret[name]) {
      ret[name] = item.value || item._value || '';
    }
  });

  return ret;
}

export function getNewEmail(data) {
  // TODO 适配各个渠道
  return data?.email || data?.emailOrMobile || data?.['billing[email]'] || data?.basic_email || data?.['email-address'];
}

export function trackCartq(data) {
  const email = getNewEmail(data);

  if (!email || !isEmail(email)) {
    // console.log('未获取邮箱或邮箱不合法', email);
    return;
  }

  // 读本地旧邮箱与 cookie，用于去重：避免同一 checkout 用户重复上报 cartq
  const lsOldEmail = getLocal(STORAGE_KEY.OLD_EMAIL);
  const cookieOldEmail = getCookie(STORAGE_KEY.OLD_EMAIL);

  if (lsOldEmail !== email) {
    customerCreate({
      email,
      phone: data?.phone || '',
      sourceLocation: 'checkout'
    });
    setLocal(STORAGE_KEY.OLD_EMAIL, email);
    setCookie(STORAGE_KEY.OLD_EMAIL, email, 5);
  } else {
    // cookie 失效时仍补发一次
    if (!cookieOldEmail) {
      customerCreate({
        email,
        phone: data?.phone || '',
        sourceLocation: 'checkout'
      });
      setLocal(STORAGE_KEY.OLD_EMAIL, email);
      setCookie(STORAGE_KEY.OLD_EMAIL, email, 5);
    }
  }
}

export function debounce(func, wait) {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(context, args);
    }, wait);
  };
}

export function checkout() {
  const data = collectionForm();
  trackCartq(data);

  const handleBlur = function () {
    // console.log('邮件表单元素blur');
    const data = collectionForm();
    trackCartq(data);
  };

  // TODO 适配场景
  let emails = document.querySelectorAll('input[type=email]');
  if (emails.length < 1) {
    emails = document.querySelectorAll('input[name=email]');
  }
  if (emails.length < 1) {
    emails = document.querySelectorAll('input[name=emailOrMobile]');
  }
  if (emails.length < 1) {
    emails = document.querySelectorAll('input#email');
  }
  // 竹乐
  if (emails.length < 1) {
    emails = document.querySelectorAll('#basic_email');
  }
  // 有橙
  if (emails.length < 1) {
    emails = document.querySelectorAll('input[name="email-address"]');
  }

  emails.forEach((item) => {
    item.addEventListener('blur', handleBlur);
  });

  // if (window.jQuery) {
  //   window.jQuery(email).blur(handleBlur);
  // } else {
  //   email?.addEventListener('blur', handleBlur);
  // }

  // console.log('获取邮件表单元素', emails);
}

export const checkoutMonitor = () => {
  executeWhenReady(() => {
    if (window.location.href.includes('checkout')) {
      // console.log('邮件采集初始化');
      if ([common[1032]].includes(companyUUID)) {
        setTimeout(() => {
          checkout();
        }, 5 * 1000);
      } else {
        checkout();
      }
    }
  });
};
